import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { List, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Radio from "@mui/material/Radio";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import NavigateNextOutlinedIcon from "@mui/icons-material/NavigateNextOutlined";
import NavigateBeforeOutlinedIcon from "@mui/icons-material/NavigateBeforeOutlined";
import { Carousel } from "react-responsive-carousel";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import { unicodeToString } from "../../../Js/Common";
import AudioButton from "../../../Components/Media/AudioButton";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "presentation",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 1,
};

const OP = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();
  let [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  let [sidesContent, setSidesContent] = useState(null);
  let [titles, setTitles] = useState(null);
  let [logObj, setLogObj] = useState(initLogObj);
  let [isPlayA, setIsPlayA] = useState(false);
  let [isPlayB, setIsPlayB] = useState(false);
  let [isPlayExA, setIsPlayExA] = useState(false);
  let [isPlayExB, setIsPlayExB] = useState(false);

  useEffect(() => {
    if (props.content) {
      console.log("^^^^^^", props.content);
      setSidesContent(props.content.epage.options.content);
      setTitles(props.content.epage.options.content_title);
      setLogObj({
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
      });
    }
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
  }, [logObj]);

  return (
    <Grid item xs={12} sx={{}}>
      {sidesContent && (
        <Box
          sx={{
            border: 1,
            borderColor: "#EAECEE",
            borderRadius: 5,
            py: 2,
            mx: 6,
            mt: 1,
          }}
           
        >
          <Grid
            container
            sx={{
              flexDirection: "row",
              flexFlow: "wrap",
              justifyContent: "center",
              px: 2,
              gap: 1,
            }}
          >
            {/* <Grid item xs={4} sx={{ textAlign: 'center', mt: 3 }}>
                            <CBTMedia />
                        </Grid> */}
            <Grid item xs={9}>
              <Carousel
                showIndicators={false}
                //onChange={setCurrentWord}
                showArrows={false}
                selectedItem={currentSlideIndex}
                showStatus={false}
              >
                {sidesContent.sideA.map((val, index) => {
                  return (
                    <Grid
                      container
                      sx={{
                        textAlign: "center",
                        my: 2,
                        mt: 4,
                        px: 3,
                        alignItems: "center",
                      }}
                    >
                      <Grid item xs={2}>
                        {currentSlideIndex > 0 && (
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            onClick={() => {
                              setCurrentSlideIndex(currentSlideIndex - 1);
                            }}
                          >
                            <NavigateBeforeOutlinedIcon
                              sx={{ color: "primary.main", fontSize: "3rem",
                              "@media (min-width: 1636px)": {
                                fontSize: "4rem",
                              }, }}
                            />
                          </IconButton>
                        )}
                      </Grid>
                      <Grid item xs={8}>
                        <Typography
                          sx={{
                            color: "primary.main",
                            fontSize: "1.4rem",
                            fontWeight: "700",
                            "@media (min-width: 1636px)": {
                              fontSize: "2.2rem",
                            },
                          }}
                        >
                          {unicodeToString(val.text)}
                        </Typography>
                        {sidesContent["sideA"][currentSlideIndex]["media"][
                          "audio"
                        ] && (
                          <AudioButton
                            expertAudio={
                              sidesContent["sideA"][currentSlideIndex]["media"][
                                "audio"
                              ]
                            }
                            playStatus={(status) => setIsPlayA(status)}
                          >
                            <IconButton edge="end" aria-label="delete">
                              {isPlayA ? (
                                <PauseCircleOutlineIcon
                                  sx={{
                                    color: "primary.main",
                                    fontSize: "2.2rem",
                                    boxShadow: 4,
                                    borderRadius: 10,
                                    "@media (min-width: 1636px)": {
                                      fontSize: "3.2rem",
                                    },
                                  }}
                                />
                              ) : (
                                <PlayCircleFilledWhiteOutlinedIcon
                                  sx={{
                                    color: "primary.main",
                                    fontSize: "2.2rem",
                                    boxShadow: 4,
                                    borderRadius: 10,
                                    "@media (min-width: 1636px)": {
                                      fontSize: "3.2rem",
                                    },
                                  }}
                                />
                              )}
                            </IconButton>
                          </AudioButton>
                        )}
                      </Grid>
                      <Grid item xs={2}>
                        {currentSlideIndex < sidesContent.sideA.length - 1 && (
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            onClick={() => {
                              setCurrentSlideIndex(currentSlideIndex + 1);
                            }}
                          >
                            <NavigateNextOutlinedIcon
                              sx={{ color: "primary.main", fontSize: "3rem",
                              "@media (min-width: 1636px)": {
                                fontSize: "4rem",
                              }, }}
                            />
                          </IconButton>
                        )}
                      </Grid>
                    </Grid>
                  );
                })}
              </Carousel>
              <Box
                sx={{
                  textAlign: "center",
                  border: 1,
                  borderRadius: 10,
                  borderColor: "#EFEFEF",
                  padding: "0.6em",
                  my: 3,
                  mx: 10,
                }}
              >
                <Typography
                  sx={{
                    color: "primary.main",
                    fontSize: "1.2rem",
                    fontWeight: "500",
                    "@media (min-width: 1636px)": {
                      fontSize: "2rem",
                    },
                  }}
                >
                  {titles ? unicodeToString(titles.right) : ""}:{" "}
                  {sidesContent
                    ? unicodeToString(
                        sidesContent["sideB"][currentSlideIndex]["text"]
                      )
                    : ""}
                </Typography>
                {sidesContent["sideB"][currentSlideIndex]["media"]["audio"] && (
                  <AudioButton
                    expertAudio={
                      sidesContent["sideB"][currentSlideIndex]["media"]["audio"]
                    }
                    playStatus={(status) => setIsPlayB(status)}
                  >
                    <IconButton edge="end" aria-label="delete">
                      {isPlayB ? (
                        <PauseCircleOutlineIcon
                          sx={{
                            color: "primary.main",
                            fontSize: "2.2rem",
                            boxShadow: 4,
                            borderRadius: 10,
                            "@media (min-width: 1636px)": {
                              fontSize: "3.2rem",
                            },
                          }}
                        />
                      ) : (
                        <PlayCircleFilledWhiteOutlinedIcon
                          sx={{
                            color: "primary.main",
                            fontSize: "2.2rem",
                            boxShadow: 4,
                            borderRadius: 10,
                            "@media (min-width: 1636px)": {
                              fontSize: "3.2rem",
                            },
                          }}
                        />
                      )}
                    </IconButton>
                  </AudioButton>
                )}
              </Box>
              {sidesContent &&
                sidesContent["sideA"][currentSlideIndex]["example"]["media"][
                  "audio"
                ] &&
                sidesContent["sideA"][currentSlideIndex]["example"]["text"] && (
                  <>
                    <List
                      dense
                      sx={{
                        borderBottom: 1,
                        borderRadius: 10,
                        borderColor: "#EFEFEF",
                        padding: "0.2em",
                        my: 4,
                        mx: 5,
                      }}
                    >
                      <ListItem
                        sx={{ pa: 0 }}
                        secondaryAction={
                          <AudioButton
                            expertAudio={
                              sidesContent["sideA"][currentSlideIndex][
                                "example"
                              ]["media"]["audio"]
                            }
                            playStatus={(status) => setIsPlayExA(status)}
                          >
                            <IconButton edge="end" aria-label="delete">
                              {isPlayExA ? (
                                <PauseCircleOutlineIcon
                                  sx={{
                                    color: "primary.main",
                                    fontSize: "2.2rem",
                                    boxShadow: 4,
                                    borderRadius: 10,
                                    "@media (min-width: 1636px)": {
                                      fontSize: "3.2rem",
                                    },
                                  }}
                                />
                              ) : (
                                <PlayCircleFilledWhiteOutlinedIcon
                                  sx={{
                                    color: "primary.main",
                                    fontSize: "2.2rem",
                                    boxShadow: 4,
                                    borderRadius: 10,
                                    "@media (min-width: 1636px)": {
                                      fontSize: "3.2rem",
                                    },
                                  }}
                                />
                              )}
                            </IconButton>
                          </AudioButton>
                        }
                      >
                        <ListItemText
                          classes={{ primary: classes.ListItemText }}
                          sx={{ color: "primary.main", pl: 2 }}
                        >
                          <Typography
                            sx={{ fontWeight: "700", fontSize: "1rem",
                            "@media (min-width: 1636px)": {
                              fontSize: "1.4rem",
                            }, }}
                          >
                            Examples:
                          </Typography>
                          <Typography
                            classes="fontSize"
                            sx={{ fontSize: "0.9rem","@media (min-width: 1636px)": {
                              fontSize: "1.4rem",
                            }, }}
                          >
                            {unicodeToString(
                              sidesContent["sideA"][currentSlideIndex][
                                "example"
                              ]["text"]
                            )}
                          </Typography>
                        </ListItemText>
                      </ListItem>
                    </List>
                    <List
                      dense
                      sx={{
                        borderBottom: 1,
                        borderRadius: 10,
                        borderColor: "#EFEFEF",
                        padding: "0.2em",
                        my: 4,
                        mx: 5,
                      }}
                    >
                      <ListItem
                        sx={{ pa: 0 }}
                        secondaryAction={
                          <AudioButton
                            expertAudio={
                              sidesContent["sideB"][currentSlideIndex][
                                "example"
                              ]["media"]["audio"]
                            }
                            playStatus={(status) => setIsPlayExB(status)}
                          >
                            <IconButton edge="end" aria-label="delete">
                              {isPlayExB ? (
                                <PauseCircleOutlineIcon
                                  sx={{
                                    color: "primary.main",
                                    fontSize: "2.2rem",
                                    boxShadow: 4,
                                    borderRadius: 10,
                                    "@media (min-width: 1636px)": {
                                      fontSize: "3.2rem",
                                    },
                                  }}
                                />
                              ) : (
                                <PlayCircleFilledWhiteOutlinedIcon
                                  sx={{
                                    color: "primary.main",
                                    fontSize: "2.2rem",
                                    boxShadow: 4,
                                    borderRadius: 10,
                                    "@media (min-width: 1636px)": {
                                      fontSize: "3.2rem",
                                    },
                                  }}
                                />
                              )}
                            </IconButton>
                          </AudioButton>
                        }
                      >
                        <ListItemText
                          classes={{ primary: classes.ListItemText }}
                          sx={{ color: "primary.main", pl: 2 }}
                        >
                          <Typography
                            sx={{ fontWeight: "700", fontSize: "0.9rem",
                            "@media (min-width: 1636px)": {
                              fontSize: "1.4rem",
                            }, }}
                          >
                            Examples:
                          </Typography>
                          <Typography
                            classes="fontSize"
                            sx={{ fontSize: "0.9rem","@media (min-width: 1636px)": {
                              fontSize: "1.4rem",
                            }, }}
                          >
                            {unicodeToString(
                              sidesContent["sideB"][currentSlideIndex][
                                "example"
                              ]["text"]
                            )}
                          </Typography>
                        </ListItemText>
                      </ListItem>
                    </List>
                  </>
                )}
            </Grid>
          </Grid>
        </Box>
      )}
    </Grid>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
    height: "60vh",
    overflow: "auto",
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  fontSize: {
    fontSize: "0.9rem !important",
  },
});
export default OP;
